import React, {Component} from "react"
import {translate} from "translate"
import propTypes from "prop-types"
import {Link} from "react-router"
import shop from "../../shop/shop"
import Price from "../Price/Price"
import "./CartMini.scss"
import {Button} from "elemental"
// import Button from "elemental"

const productEntries = ({ remove, interactive }) => shop.cart.map( (product, key) => {
  const hasRabatt = product.pinfos && product.pinfos.zuab !== "0"
  return (
    <div key={key}
         className="cart-product">
      <div className="product-thumbnail">
        <Link to={`/product/${product.map_id}`}>
          <img src={product.img_src_small}
               style={{
                 width:     "40px",
                 maxHeight: "26px"
               }}
               alt=""/>
        </Link>
      </div>
      <div className="product-description">
        <div className="text-small">
          <Link to={`/product/${product.map_id}`}>
            #{product.article_nr} <br />
            <strong>{product.count * product.unit_multi} {translate( "cart.piece" )}</strong> <span
            className="title">{(product.title) ? product.title : ""}</span> <br />
          </Link>
          {hasRabatt && <Price className="black-50 f6 strike">{product.count * product.pinfos.brutto * product.unit_multi}</Price>}
         <strong> <Price className={`price ${hasRabatt && "red"}`}>{product.count * product.price * product.unit_multi}</Price></strong>
          {/*<strong><Price>{product.count * product.price * product.unit_multi}</Price></strong>*/}
        </div>
      </div>
      {interactive && <div className="product-actions">
        <Button onClick={() => remove( product )}
                style={{
                  width:  "32px",
                  height: "32px"
                }}
                size="xs"> <i className=" icon-cancel"/> </Button>
      </div>}
    </div>
  )
} )

export default class CartMini extends Component {

  static propTypes = {
    interactive: propTypes.bool
  }

  static defaultProps = {
    interactive: true
  }

  constructor(props) {
    super( props )
    console.log( `props`, props )
    this.state = {
      products: productEntries( { remove: this.remove, interactive: props.interactive } )
    }
  }

  remove = (product) => {
    console.log( `removing`, product )
    shop.cart.remove( product )
  }

  componentDidMount() {
    this.cartListener = shop.cart.hooks.changed.add( this.updateCart )
  }

  updateCart = () => {
    let products = productEntries( { remove: this.remove, interactive: this.props.interactive } )
    this.setState( { products } )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  render() {
    let { products } = this.state
    return (
      <div>
        <div className="cart cart-mini">
          {products || null}
          <div className="total">
            {translate( "cart.subtotal" )}
            <span className="pull-right">
                        <Price>{shop.cart.sum}</Price>
                  </span>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Cart/CartMini.js